import { PATH_IMAGE } from './Environment';

export const CHECKIN_ICON = `${PATH_IMAGE}icon-map-checkin.svg`;
export const COMPANY_ICON = `${PATH_IMAGE}icon-map-company.svg`;
export const OPPORTUNITY_ICON = `${PATH_IMAGE}icon-map-opportunity.svg`;
export const COMPANY_CHECKIN_ICON = `${PATH_IMAGE}icon-map-company-checkin.svg`;
export const OPPORTUNITY_CHECKIN_ICON = `${PATH_IMAGE}icon-map-opportunity-checkin.svg`;
export const FAST_CHECKIN_ICON = `${PATH_IMAGE}icon-map-fast-checkin.svg`;
export const DOCUMENT_PLACEHOLDER_ICON = `${PATH_IMAGE}generic_doc.png`;
export const MAP_PIN = `${PATH_IMAGE}img-pin-on.svg`;
